import { GetterTree } from 'vuex';
import { AuthState } from './types';
import { RootState } from '../../types';
import { AppContext } from '../../context';

const getAuthDataFromLocalStorage = () => (): any =>
    JSON.parse(localStorage.getItem(AppContext.InternalConfig.LocalStorage.AUTH_KEY));

const getAmIAuthed = () => (): boolean => {
    const authData = getAuthDataFromLocalStorage()();
    return !!authData;
};

const getId = () => (): number => {
    const authData = getAuthDataFromLocalStorage()();
    return authData ? (authData.id as number) : 0;
};

const getUid = () => (): string => {
    const authData = getAuthDataFromLocalStorage()();
    return authData ? authData.uid : '';
};

const getName = () => (): string => {
    const authData = getAuthDataFromLocalStorage()();
    return authData ? authData.name : '';
};

const getAfterLogin = () => (): boolean => {
    const authData = getAuthDataFromLocalStorage()();
    return authData ? authData.afterLogin : false;
};

const getAuthorities = state => (): Array<string> => state.myAuthorities.list;

export const getters: GetterTree<AuthState, RootState> = {
    getAuthData: getAuthDataFromLocalStorage,
    amIAuthed: getAmIAuthed,
    id: getId,
    uid: getUid,
    name: getName,
    afterLogin: getAfterLogin,
    authorities: state => getAuthorities(state),
};
